import { Component, OnInit, Input } from '@angular/core';
import { THTransaction } from 'src/app/interfaces/api/transaction';
import { Browser } from '@capacitor/browser';

@Component({
  selector: 'app-faktur-card',
  templateUrl: './faktur-card.component.html',
  styleUrls: ['./faktur-card.component.scss'],
})
export class FakturCardComponent implements OnInit {
  @Input() isLoading: boolean;
  @Input() transaction: THTransaction;
  @Input() mode: 'default' | 'no-border' = 'default';

  constructor() {}

  ngOnInit() {}

  openExternalSite = async () => {
    await Browser.open({
      url: this.transaction?.faktur_pajak?.file,
    });
  };
}
